import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'CDMS-Portal-U2-empty',
    templateUrl: './empty.component.html',
    imports: [RouterOutlet]
})
export class EmptyComponent {

  constructor() { }

}
